var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppe-form',{attrs:{"entityName":"B2","formkey":"b2_eu","title":"B2. Sources de dangers","title-field":"{company.name}","sub-title":"","schema":_vm.schema,"endpoint":_vm.endpoint,"redirect":'/ppe_eu/home/:operationid'}})}
var staticRenderFns = []

export { render, staticRenderFns }